import { FadeUp, Overline } from "../components/Motion";
import { SERVICES } from "../data/content";

const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#0A0A0A] py-28 md:py-40">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <FadeUp>
        <Overline>What We Shoot</Overline>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6">
          Three lenses, <span className="italic">one</span> studio.
        </h2>
      </FadeUp>

      <div className="mt-20 flex flex-col divide-y divide-white/10">
        {SERVICES.map((s, i) => {
          const plain = s.title.replace(s.titleItalic, "").trim();
          return (
            <FadeUp key={s.num} delay={i * 0.08}>
              <div
                data-testid={`service-row-${s.num}`}
                className="group grid grid-cols-1 md:grid-cols-12 items-center gap-8 py-12"
              >
                <div className="md:col-span-1 font-mono text-sm text-[#F5A623]">{s.num}</div>

                <div className="md:col-span-4">
                  <h3 className="font-serif text-3xl md:text-4xl leading-tight">
                    {plain} <span className="italic">{s.titleItalic}</span>
                  </h3>
                  <div className="flex flex-wrap gap-2 mt-4">
                    {s.tags.map((t) => (
                      <span key={t} className="text-[11px] uppercase tracking-wider text-[#A1A1AA] border border-white/15 rounded-full px-3 py-1">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>

                <p className="md:col-span-4 text-[#A1A1AA] leading-relaxed">{s.desc}</p>

                <div className="md:col-span-3 overflow-hidden rounded-sm aspect-[4/3]">
                  <img
                    src={s.image}
                    alt={s.title}
                    className={`h-full w-full object-cover ${s.pos || "object-center"} grayscale-[0.35] group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-[filter,transform] duration-700 ease-out`}
                  />
                </div>
              </div>
            </FadeUp>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
